import {
  Box,
  CircularProgress,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { DotsThree, ImageSquare, VideoCamera } from "phosphor-react";

const MediaDrawerGridItem = ({
  isUploading,
  isVideo,
  fileName,
  previewSrc,
  status,
}) => {
  return (
    <Box
      sx={{
        bgcolor: "transparent",
        borderRadius: "5px",
        overflow: "hidden",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          minHeight: 30,
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          spacing={0.75}
          sx={{ minWidth: 0, flex: 1 }}
        >
          {isUploading ? (
            <CircularProgress
              size={16}
              sx={{ color: "#6C65D9", flexShrink: 0 }}
            />
          ) : isVideo ? (
            <VideoCamera size={16} color="#B1B5C9" style={{ flexShrink: 0 }} />
          ) : (
            <ImageSquare size={16} color="#B1B5C9" style={{ flexShrink: 0 }} />
          )}
          <Typography
            noWrap
            sx={{
              fontSize: 12,
              color: "#B1B5C9",
            }}
          >
            {fileName}
          </Typography>
        </Stack>
        {status === "uploading" ||
        status === "failed" ||
        status === "canceled" ? (
          <Typography sx={{ fontSize: 12, color: "#f9f9f9" }}>
            {status}
          </Typography>
        ) : (
          <IconButton
            size="small"
            aria-label="Media options"
            sx={{
              color: "#B1B5C9",
              "&:hover": {
                color: "#F9F9F9",
                bgcolor: "rgba(255,255,255,0.06)",
              },
            }}
          >
            <DotsThree size={18} weight="bold" />
          </IconButton>
        )}
      </Stack>

      <Box
        sx={{
          marginTop: "10px",
          position: "relative",
          aspectRatio: "16 / 10",
          bgcolor: "#1B1D28",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {isVideo ? (
          <video
            autoPlay
            loop
            muted
            playsInline
            src={previewSrc}
            alt={fileName || "video"}
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        ) : (
          <img
            src={previewSrc}
            alt={fileName || "image"}
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        )}
      </Box>
    </Box>
  );
};

export default MediaDrawerGridItem;
